import { createReducer, on } from '@ngrx/store';
import { updateLoggedInUser } from './UserInfo.action';
import { UserInformation } from 'src/app/shared/models/app-models';

const initialState: UserInformation = {
    userName: '',
    token: '',
    fullName: '',
    roles: []
}

export const userReducer = createReducer(initialState,
    on(updateLoggedInUser, (state, { user }) => {
        return { ...user }
    })
)